import firebase from 'firebase/compat/app'
import { PageId } from 'constants/pages'
import { TStep } from 'nove8/types'
import { isCoachSelectionTestVariant } from '../abtest/isCoachSelectionTestVariant'
import { STEPS_WOOFZ_WOOFY } from '../constants/steps'

const STEPS_WOOFZ_WOOFY_COACH: TStep[] = [
  { pageId: PageId.COACH_WOOFY },
  { pageId: PageId.CHAT_WOOFY },
  ...STEPS_WOOFZ_WOOFY.slice(6),
]

export const getWoofzWoofySteps = (
  firebaseRemoteConfig: firebase.remoteConfig.RemoteConfig | null,
): TStep[] => {
  if (isCoachSelectionTestVariant(firebaseRemoteConfig)) {
    return STEPS_WOOFZ_WOOFY_COACH
  }

  return STEPS_WOOFZ_WOOFY
}
